import { Component, OnInit } from '@angular/core';
import { ModalDirective, BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-sponsorlinks',
  templateUrl: './sponsorlinks.component.html',
  styleUrls: ['./sponsorlinks.component.scss']
})
export class SponsorlinksComponent implements OnInit {

  constructor(private modalRef: BsModalRef) { }

  ngOnInit(): void {
  }

  public onCancel(): void {
    this.modalRef.hide();
  }

}
